import React, { useRef, useState, useEffect } from "react";

export const FxMoDetailList = (props) => {
  const [mo, setMo] = useState(props.mo);
  const [isHovering, setIsHovering] = useState(0);

  return (
    <div
      className={"MoState"}
      onMouseOver={() => setIsHovering(1)}
      onMouseOut={() => setIsHovering(0)}
    >
      <li
        key={mo.moNo}
        className={
          "MoState " +
          (mo.moOnlineStVal === 1 ? "onlineBackgroup" : mo.moOnlineStVal === 0 ? "offlineBackgroup" : "unknownlineBackgroup")
        }
      >
        {mo.moDispName}
      </li>
      {isHovering ? <FxMoDetailInfo mo={mo} /> : ""}
    </div>
  );
};

const FxMoDetailInfo = (props) => {
  const [mo, setMo] = useState(props.mo);
  const [modalOpen, setModalOpen] = useState(true);

  return (
    <div className="MoDetailState">
      <table border="1" width="50%" height="20" cellSpacing="5">
        <thead>
          <tr>
            <th>센서명</th>
            <th>센서종류</th>
            <th>센서상태</th>
            <th>상태변화일시</th>
          </tr>
        </thead>

        <tbody>
          <tr align="center">
            <td>{mo.moDispName}</td>
            <td>{mo.moType}</td>
            {mo.moOnlineStVal === 1 ? <td>정상</td> : <td>이상</td>}
            <td>{mo.moOnlineStChgDtm}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default FxMoDetailList;
